/**
 * Subsequence fuzzy match with a simple score (higher = better). Returns null if query chars
 * are not found in order within the target string.
 */
export function fuzzyMatchScore(query: string, target: string): number | null {
  const q = query.trim().toLowerCase();
  if (!q) return 0;

  const t = target.toLowerCase();
  if (t.includes(q)) {
    return 1000 + (200 - t.indexOf(q));
  }

  let qi = 0;
  let score = 0;
  let lastMatchIndex = -1;

  for (let i = 0; i < t.length && qi < q.length; i += 1) {
    if (t[i] !== q[qi]) continue;
    score += 10;
    if (lastMatchIndex === i - 1) score += 5;
    if (i === 0 || t[i - 1] === ' ' || t[i - 1] === '-' || t[i - 1] === '/') score += 3;
    lastMatchIndex = i;
    qi += 1;
  }

  if (qi < q.length) return null;
  return score;
}

export function fuzzyFilterAndSort<T>(
  items: T[],
  query: string,
  getLabel: (item: T) => string,
): T[] {
  const q = query.trim();
  if (!q) return items;

  const scored: Array<{ item: T; score: number; index: number }> = [];
  items.forEach((item, index) => {
    const score = fuzzyMatchScore(q, getLabel(item));
    if (score !== null) scored.push({ item, score, index });
  });

  scored.sort(
    (a, b) =>
      b.score - a.score ||
      a.index - b.index ||
      getLabel(a.item).localeCompare(getLabel(b.item), undefined, { sensitivity: 'base' }),
  );
  return scored.map((entry) => entry.item);
}
